// https://www.chartjs.org/docs/2.9.4/
import Chart from 'chart.js/auto'
import annotationPlugin from 'chartjs-plugin-annotation'
Chart.register( annotationPlugin )

document.addEventListener( "DOMContentLoaded", () => {
    calc()

    document.body.addEventListener( "submit", ( e ) => {
        if ( e.target && e.target.id === 'calculateForm' ) {
            e.preventDefault()
        }
    } ) 
} )

const displayChart = ( request ) => {
    // console.log( request );

    const maxRest = Math.ceil( parseInt( request.cost ) / 100000 )*100000
    const maxStep = 50000;

    // year 0 to 55
    let arrY = []

    const cost = parseFloat( request.cost );

    let ges = cost;
    let arrGs = [cost];
    let arrGs2 = [cost];

    let gu = cost;
    let arrGu = [cost];
    let arrGu2 = [0];

    // years
    for( let a = 0; a <= 50; a++ ) {
        arrY.push( `Jahr ${a}` );
    }

    // black line / bar
    let gu2_add = 0;
    for ( let a = 0; a < request.nd_ges; a++ ) {
        ges = ges - parseFloat( request.abs_ges );
        arrGs.push( ges );
        arrGs2.push( ges );

        if( a <= request.years_diff && request.abs_done > 0 ) {
            gu2_add = gu2_add + parseFloat( request.abs_ges );
            arrGu.push( ges );
            arrGu2.push( gu2_add );
            gu = ges;
        }
    }
    arrGs2.reverse();

    // orange line / bar
    if( request.res_amort >= 0 ) {
        for ( let a = 0; a < request.nd_gut; a++ ) {
            gu = gu - parseFloat( request.abs_gut );
            gu2_add = gu2_add + parseFloat( request.abs_gut );

            arrGu.push( gu );
            arrGu2.push( gu2_add );
        }
    } else {
        arrGu = [];
        arrGu2 = [];
        // console.log('orange is negative', arrGu, arrGu2);
    }

    // arrGu2.reverse();

    const canvasWrapper = document.getElementById('canvas')
    if( canvasWrapper ) { 
        canvasWrapper.innerHTML = ''
        const graph = document.createElement('canvas')
        graph.id = 'graph'
        graph.width = '600'
        graph.height = '350'
        canvasWrapper.appendChild( graph )
        const ctx = graph.getContext('2d')

        const params = {
            type: 'line',
            data: {
                labels: arrY,
                datasets: [
                    
                    // black line
                    {
                        label: 'Ohne Gutachten',
                        data: arrGs,
                        borderColor: 'rgba(26, 27, 42, 1)',
                        backgroundColor: 'rgba(26, 27, 42, 1)',
                        borderWidth: 1,
                    },
                    // black bar
                    {
                        label: '',
                        data: arrGs2,
                        borderColor: 'rgba(26, 27, 42, .3)',
                        backgroundColor: 'rgba(26, 27, 42, .3)',
                        borderWidth: 1,
                        type: 'bar'
                    },

                    // orange line
                    {
                        label: 'Mit Gutachten',
                        data: arrGu,
                        borderColor: 'rgba(255, 84, 0, 1)',
                        backgroundColor: 'rgba(255, 84, 0, 1)',
                        borderWidth: 1
                    },
                    // orange bar
                    {
                        label: '',
                        data: arrGu2,
                        borderColor: 'rgba(255, 84, 0, .3)',
                        backgroundColor: 'rgba(255, 84, 0, .3)',
                        borderWidth: 1,
                        type: 'bar'
                    },
                    
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                // aspectRatio: 1,
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Dauer der Abschreibung'
                        },
                        grid: {
                            display: true
                        },
                        min: 0,
                        max: 55,
                        ticks: {
                            stepSize: 1,
                            color: '#000'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Gebäudewert'
                        },
                        grid: {
                            display: true
                        },
                        min: 0,
                        max: maxRest,
                        ticks: {
                            stepSize: maxStep,
                            color: '#000'
                        }                 
                    }
                },
                plugins: {
                    legend: false,
                    title: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: ( context ) => {
                                let value = (Math.round(context.parsed.y * 100) / 100).toFixed(2)
                                if( value < 1 ) {
                                    value = '0.00'
                                }
                                return `${ context.dataset.label } ${ value } €`
                            }
                        }
                    }
                }
            }
        }

        const chart = new Chart( ctx, params );
    }
} 

const calc = () => {
    let params = '';
    let object = {};
    const wrapper = document.getElementById('afa')
    const form = document.getElementById('calculateForm')
    const loader = document.getElementById('loader')

    if( loader ) loader.style.display = 'flex'
    
    if( form ) {
        params = new FormData( form )
    } else {
        params = new FormData()
    }
    params.append('nonce', afa.nonce);
    params.append('disable_cta', wrapper.getAttribute('disable-cta') ?? '');
    params.forEach(function(value, key) {
        object[key] = ( object[key] ? object[key] + ', ' : '' ) + value;
    });

    console.log(object);

    let queryString = window.location.search
    queryString = queryString.replace('?', '');
    
    fetch( `${ afa.ajax_url }?action=${ afa.action }&${ queryString }` , {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify( object )
    })
    .then((response) => response.json())
    .then((data) => {
        wrapper.innerHTML = data.form;
        displayChart( data.request );
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

const gestMarker = () => {
    document.body.addEventListener( "change", handleGest, false )
}
const handleGest = ( e ) => {
    if ( e.srcElement?.name && e.srcElement.name === 'gest' ) {
        const gest_m = document.getElementById('gest_m')
        gest_m.checked = true
        calc();
    }
}

const marker = () => {
    document.body.addEventListener( "change", handle, false )
}
const handle = ( e ) => {
    if ( 
        e.srcElement?.name && 
        ( 
            e.srcElement.name === 'nk_p' || 
            e.srcElement.name === 'nk_w' ||
            e.srcElement.name === 'mk_p' ||
            e.srcElement.name === 'mk_w' ||
            e.srcElement.name === 'gb_p' ||
            e.srcElement.name === 'gb_w' ||
            e.srcElement.name === 'deadline'
        )
    ) {
        e.target.nextElementSibling.checked = true
        calc();
    }
}

const selects = () => {
    document.body.addEventListener( "change", handleSelect, false )
}
const handleSelect = ( e ) => {
    if ( e.srcElement?.name && e.srcElement.name === 'country' ) {
        const gest_m = document.getElementById('gest_m')
        gest_m.checked = false
        calc() // muss hier rein, da sonst permanent getriggert wird
    }
}

window.gestMarker = gestMarker
window.calc = calc
window.marker = marker
window.selects = selects